import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  LabelText,
  HiddenCheckbox,
  StyledCheckboxWrapper,
  Icon,
} from './components/CheckboxStyles';
import { useCheckbox } from './hooks/useCheckbox';
import { getCheckboxLabel } from './utils/checkboxHelpers';

const Checkbox = ({ checked, onChange, label, disabled, ...rest }) => {
  const { handleChange } = useCheckbox({ onChange, disabled });
  const displayLabel = getCheckboxLabel(label);

  return (
    <Container disabled={disabled}>
      <HiddenCheckbox checked={checked} onChange={handleChange} disabled={disabled} {...rest} />
      <StyledCheckboxWrapper checked={checked} disabled={disabled}>
        <Icon className="fas fa-check" checked={checked} />
      </StyledCheckboxWrapper>
      {displayLabel && <LabelText>{displayLabel}</LabelText>}
    </Container>
  );
};

Checkbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};

Checkbox.defaultProps = {
  checked: false,
  onChange: undefined,
  label: '',
  disabled: false,
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Checkbox/Checkbox.jsx